<template lang="pug">
.years-container
	YourPlanColumn(
		v-for="( year, m ) in years"
		:key="m"
		:title="year.title"
		:sections="year.sections"
		@selectSection="onSelectSection($event, year.title)"
	)
</template>

<script>
import YourPlanColumn from '@/components/YourPlanColumn';

export default {
  name       : 'your-plan-content',
  components : {
    YourPlanColumn
  },

  props : {
    studentPlan : Object
  },

  computed : {
    years() {
      return [
        this.format( 'freshman' ),
        this.format( 'sophomore' ),
        this.format( 'junior' ),
        this.format( 'senior' )
      ];
    }
  },

  methods : {
    format( key ) {
      // if ( !this.studentPlan[key] ) console.log( 'no sections?', this.studentPlan[key], key, this.studentPlan );
      return {
        title    : key,
        sections : this.studentPlan[key]
      };
    },

    onSelectSection( index, year ) {
      this.$emit( 'selectSection', {
        year,
        index
      } );
    }
  }
};
</script>

<style lang="scss" scoped>
.years-container {
	display: grid;
	gap: 28px;

	@include md {
		margin-bottom: 60px;
		grid-template-columns: repeat(2, 1fr);
	}

	@include xl {
		grid-template-columns: repeat(4, 1fr);
	}


	// @include sm {
	// 	grid-template-columns: repeat(2, 1fr);
	// }

	// @include md {
	// 	grid-template-columns: repeat(3, 1fr);
	// }

	// @include xl {
	// 	grid-template-columns: repeat(4, 1fr);
	// }
}
</style>
